const deviceHubMake = [
    'Aquassist',
    'Walchem',
    'Emec'];
export default deviceHubMake;
